// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Vd-m","productName":"Table_productName__28LNM"};